import { FirebaseApp } from "firebase/app";
import React, { useEffect, useRef } from "react";
import { ReactElement } from "react";
import { initializeApp } from "firebase/app";
import { Analytics, getAnalytics } from "firebase/analytics";
import { firebaseConfigDev, firebaseConfigProd } from "../analytics/firebaseConfig";
import { useEnvironment } from "../hooks/useEnvironment";

interface FirebaseProviderProps {
    onAppInitialized: (app: FirebaseApp) => void;
    onAnalyticsInitialized: (analytics: Analytics) => void;
}

export function FirebaseProvider(props: React.PropsWithChildren<FirebaseProviderProps>): ReactElement {
  const [isDevelopment] = useEnvironment();
  const initializedRef = useRef(false);
  
  useEffect(() => {
    const initializeFirebase = async () => {
      // Prevent double initialization in React Strict Mode
      if (initializedRef.current) {
        console.log("Firebase provider already initialized, skipping...");
        return;
      }
      
      //console.log("initializing firebase provider");
      initializedRef.current = true;
      
      const firebaseConfig = isDevelopment() ? firebaseConfigDev : firebaseConfigProd;
      const app = initializeApp(firebaseConfig);
      if (app != null) {
        props.onAppInitialized(app);
        //console.log("firebase provider app initialized");
      }
      try {
        const analytics = getAnalytics(app);
        if (analytics != null) {
          props.onAnalyticsInitialized(analytics);
          console.log("firebase provider analytics initialized");
        }
      } catch (error) {
        console.warn("Firebase Analytics could not be initialized (likely blocked by ad blocker or privacy settings):", error);
        // Continue without analytics - app should still work
      }

    };
    initializeFirebase();
  }, []);

  return <>{props.children}</>;
}
